import React, { Component } from 'react';
import {Link, browserHistory } from 'react-router';
import $ from 'jquery';
import { Modal,Button,Breadcrumb,Item } from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';
export default class WebSmartCart extends Component{
	constructor(props){
		super(props);
		this.state={
			cart_count:'',
			page_loading:false,
			smart_filters:[],
			smart_deals:[],
			active_filter:0,
			//  add to cart values
			replace_did:'',
			replace_deal_type:'',
			replace_qty:'',
			replace_pl_size:'',
			replace_salinity:'',
			replace_pickup_date:'',
			replace_id:'',
			replace_product_name:'',

			cart_status:false,
			cart_status_msg:'',
			clearcart_status:false,
			cart_added_status:false,
			// cart values ends here
		}
		this.getSmartFilters=this.getSmartFilters.bind(this);
		this.getSmartDeals=this.getSmartDeals.bind(this);
		this.getSmartDealsByType=this.getSmartDealsByType.bind(this);
		this.addToCart=this.addToCart.bind(this);
		this.close=this.close.bind(this);
		this.replaceCartItems=this.replaceCartItems.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
		this.tokenCheck=this.tokenCheck.bind(this);
	}
	componentDidMount()
	{
	localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals');
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('web_smartcart','/web/smartcart');
			browserHistory.push('/web/login');
		}
		else
		{
			this.getCartCount();
			this.getSmartFilters();
			this.getSmartDeals();
		}
	}
	tokenCheck()
	{
		localStorage.removeItem('user_id');
		localStorage.removeItem('token');
		window.location.reload();
	}
	getSmartFilters()
	{
		if(localStorage.user_id)
		{
		  var uid = localStorage.user_id;
		}
		else
		{
			 uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.token};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'smart_list_filters',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_filters:data.filters,
					});
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	getSmartDeals()
	{
       if(localStorage.user_id)
		{
		  var uid = localStorage.user_id;
		}
		else
		{
			 uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.token,dtype:0};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'smart_list',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_deals:data.data,
					});
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	getSmartDealsByType(dtype)
	{
		this.setState({
			active_filter:dtype,
		});
		if(localStorage.user_id)
		{
		  var uid = localStorage.user_id;
		}
		else
		{
			 uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.token,dtype:dtype}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'smart_list',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_deals:data.data,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	addToCart(did,deal_type,qty,pl,salinity,pickup_date,id,product_name)
	{
		this.setState({
			replace_did:did,
			replace_deal_type:deal_type,
			replace_qty:qty,
			replace_pl_size:pl,
			replace_salinity:salinity,
			replace_pickup_date:pickup_date,
			replace_id:id,
			replace_product_name:product_name,
		});
		if(localStorage.user_id)
		{
		  var uid = localStorage.user_id;
		}
		else
		{
			 uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.token,deal_id:did,deal_type:deal_type,quantity:qty,pl_size:pl,salinity:salinity,pickup_date:pickup_date}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'addToCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.message==="Added to cart")
				{
					// this.setState({
					// 	cart_status:true,
					// 	cart_status_msg:data.message,
					// });
					browserHistory.push('/web/mycart');
				}
				if(data.status==="success" && data.message==="Cart Updated")
				{
					this.setState({
						cart_status:true,
						cart_status_msg:data.message,
					});
				}
				if(data.status==="error"  && data.cart_flag===0)
				{
					this.setState({
						clearcart_status:true,
					});
				}
				if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
				{
					this.setState({
						cart_added_status:true,
					});
				}
				this.getCartCount();
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	replaceCartItems()
  	{
  		if(localStorage.user_id)
		{
		  var uid = localStorage.user_id;
		}
		else
		{
			 uid=0;
		}
		var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token'),deal_id:this.state.replace_did,deal_type:this.state.replace_deal_type,quantity:this.state.replace_qty,pl_size:this.state.replace_pl,salinity:this.state.replace_salinity,pickup_date:this.state.replace_pickup_date}
	    var data2=JSON.stringify(data1);
	    $.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.cart_flag===1)
				{
					// this.setState({
					// 	clearcart_status:false,
					// 	cart_status:true,
					// 	cart_status_msg:data.message,
					// });
					browserHistory.push('/web/mycart');
				}
				else
				{
					this.getCartCount();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
  	}
	close()
	{
		this.setState({
			cart_status:false,
			clearcart_status:false,
			cart_added_status:false,
		})
	}
	getCartCount()
  	{
     	if(localStorage.user_id)
     	{
     		var uid=localStorage.getItem('user_id');
     	}
     	else
     	{
     		uid=0;
     	}
      	var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token')};
      	var data2=JSON.stringify(data1);
      	$.ajax({
            method: 'POST',
            url: baseUrl+'cart_count',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
	            if(data.status==='success')
	            {
	             	this.setState({
	                  cart_count:data.cart_count,
	              	});	
	            }
	            else if(data.status==='error' && data.message==='Token mismatch')
	            {
	             	localStorage.clear();
	    			window.location.reload();
	            }
            }.bind(this),
            error: function(err)
            {
            
            }
	    });
	}
	render(){
		document.title="Smart Cart | AquaDeals";
		var smart_deals=this.state.smart_deals.map(function(data,index){
			console.log(data.cart_flag);
			return(
		        <div className="smartcartitems">	
				 <div className='row'>
				   <div className="container">
				 	<div className="col-lg-6 col-md-6 col-sm-6">
					  <Link key={index} to={data.type === 0 ? "/web/sdetails/"+data.sname+"/"+data.did : "/web/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id}>
					   <div className="col-lg-4 col-md-4 col-sm-4">
	                      <div className="item_img">
							 {data.type ===0 ? <img className="item_img" src={data.img !== null && data.img !=='' ? data.img : baseAssets+'icons/web_icons/noImage.png'} alt="" /> : <img className="item_img" src={data.img !==null && data.img !=='' ? data.img : baseAssets+'icons/web_icons/noImage.png'} alt="" /> }
						  </div>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-6"> 		
							 {data.product_name ? <h2 className="websmt_cartTitle">{data.product_name}</h2>: <h2>&nbsp;</h2>}
							 {data.brand_name !==null && data.brand_name !=="" ? <h5 className="websmt_cartBrand">{data.brand_name}</h5> :  <h5>&nbsp;</h5>}
					    </div>
					    <div className="col-lg-2 col-md-2 col-sm-2">
					     &nbsp;
					    </div> 
				     </Link>
				   </div> 
				   <div className="col-lg-6 col-md-6 col-sm-6"> 
				       <Link key={index} to={data.type === 0 ? "/web/sdetails/"+data.sname+"/"+data.did : "/web/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id}>  
				         <div className="col-lg-4 col-md-4 col-sm-4">
				            {data.mrp ? <h3 className="Websmt_cartMrp">₹ {data.mrp} </h3> : <h3>&nbsp;</h3>}
				         </div>
				       </Link> 
				       <div className="col-lg-4 col-md-4 col-sm-4">
				            {data.cart_flag ===1 ? <div className="websmt_cartblk"><a className="websmt_cartbtn" href="/web/mycart">GO TO CART</a></div> : <div className="websmt_cartblk"><a className="websmt_cartbtn" onClick={()=>{this.addToCart(data.deal_id,data.type,data.qty,data.pl_size,data.salinity,data.pickup_date,data.id,data.pro_name)}}>ADD TO CART</a></div>}
				       </div>
				       <div className="col-lg-4 col-md-4 col-sm-4">
				          <button  onClick={()=>{this.deleteSingleItem(data.id)}} ariaLabel="Close" className="close websmtcart_close outline" type="button">
							<span ariaHidden="true">×</span>
						  </button>
				       </div>
				    </div> 
                   
                   </div>   
				   <hr />
				 </div>
				 
			   </div>	
		    )
    	}.bind(this));
		return(
			<div className="web_Deals web_smartcart">
				{/*<Header cart_updated_count={this.state.cart_count} /> */}
				<WebHeaderInner />
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className='container' style={{marginTop:'10%'}}>
				   <Breadcrumb className="smtcrt_breadcrmb">
			          <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			          <Breadcrumb.Item active>Smart Cart</Breadcrumb.Item>
		           </Breadcrumb>
				</div>
				<section className="container Dels_cntnt">
					<div className="row smartcart_block">
					{smart_deals.length > 0 ?
					   <div className="row" style={{marginBottom:'30px'}}> 
	                	    <div className="container">
	                	        <h2 className="col-lg-6 col-md-6 col-sm-6" style={{paddingLeft:'66px'}}>Add Item</h2>
	                	        <h2 className="col-lg-6 col-md-6 col-sm-6" style={{paddingLeft:'30px'}}>Price</h2>
                            </div>
                        </div>
					:''}	
						<div className="col-md-12 del_Rgt">
							<div className="del_Rgt_Blk">
								<div className="col-md-12"></div>
                                <div className="clr"></div>
                                <div className="row itm_lst">
                                	{smart_deals.length > 0 ? smart_deals : <div className="web_Nodata">No Previous Orders Found</div>}
								</div>
							</div>
						</div>
						<Modal className="M_pro_full_dtls_modal"  show={this.state.cart_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize:'16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					  		<Modal.Body>
					  			<h4 style={{fontSize:'14px',color:'#666'}}>{this.state.cart_status_msg}</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
						  		<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>Close</Button>
						  	</Modal.Footer>
					  	</Modal>
					  	<Modal className="M_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					 		<Modal.Body>
					  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {this.state.replace_pro_title}?</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
								<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
								<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems()}}>YES</Button></a>
					  		</Modal.Footer>
						</Modal>
						<Modal className="M_pro_full_dtls_modal"  show={this.state.cart_added_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize:'16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					  		<Modal.Body>
					  			<h4 style={{fontSize:'14px',color:'#666'}}>Product already added to the cart!</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
						  		<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>Close</Button>
						  	</Modal.Footer>
					  	</Modal>
					</div>
				</section>
				<WebFooter />
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/SmartCart/Web_SmartCart.js
 **/